import {
  AccessListSearchCriteria,
  AccessRightLevelEnum,
  FetchPermissionsType,
} from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace PermissionActions {
  export class FetchPermissions {
    static readonly type = '[Permissions] Fetch Users/groups List';
    constructor(public payload: FetchPermissionsType) {}
  }
  export class ChangeUserPermission {
    static readonly type = '[Permissions] Update/revoke User permissions';
    constructor(
      public payload: {
        entitlementType: string;
        entitlementId: string;
        entitledEntityType: string;
        entitledEntityId: string;
        level: AccessRightLevelEnum;
      },
    ) {}
  }

  export class ChangeGroupPermission {
    static readonly type = '[Permissions] Update/revoke group permissions';
    constructor(
      public payload: {
        entitlementType: string;
        entitlementId: string;
        entitledEntityType: string;
        entitledEntityId: string;
        level: AccessRightLevelEnum;
      },
    ) {}
  }

  export class FetchModuleUsersWithViewAccess {
    static readonly type = '[Permissions] Fetch Module Users with View Access';
    constructor(public filter: AccessListSearchCriteria) {}
  }
  export class FetchModuleGroupsWithViewAccess {
    static readonly type = '[Permissions] Fetch Module Groups with View Access';
    constructor(public filter: AccessListSearchCriteria) {}
  }
  export class FetchUserPermissions {
    static readonly type = '[Permissions] Fetch User Permissions';
  }

  export class SetActiveRouteAccessLevel {
    static readonly type = '[Permissions] Set Active Route Access Permission';
    constructor(public payload: AccessRightLevelEnum) {}
  }
}
